import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from 'Components';
import AppContext from 'src/AppContext';
import './NavDesktopItem.css';

const NavDesktopItem = ({
  isPinned,
  setAppState,
  filterItemValue,
  isActive,
  togglePin,
}) => (
  <li className={`nav__desktop__item ${isActive ? 'nav__desktop__item--active' : ''}`}>
    <Button
      className={`nav__desktop__item__pin ${isPinned ? 'nav__desktop__item__pin--pinned' : ''}`}
      onClick={() => togglePin(filterItemValue, isPinned)}
    >
      <Icon icon={isPinned ? 'turned_in' : 'turned_in_not'} />
    </Button>
    <Button
      className="nav__desktop__item__link"
      onClick={() => setAppState({ filterItemValue })}
    >
      {filterItemValue}
    </Button>
  </li>
);

NavDesktopItem.propTypes = {
  filterItemValue: PropTypes.string,
  isPinned: PropTypes.bool,
  isActive: PropTypes.bool,
  togglePin: PropTypes.func,
  setAppState: PropTypes.func,
};

export default (props => (
  <AppContext.Consumer>
    {context => (
      <NavDesktopItem
        {...props}
        setAppState={context.setAppState}
      />)}
  </AppContext.Consumer>
));



// WEBPACK FOOTER //
// ./src/containers/Nav/NavDesktop/NavDesktopItem/NavDesktopItem.jsx